import moment from "moment-timezone";
import { useToast } from "@/components/ui/use-toast";
import { GenerateCropProfileReportValidation, useGenerateProfileReport } from "@/lib/api/risk/profiles";
import { downloadFromS3 } from "@/lib/file";
import { CommonDestinationTimezone } from "@/lib/utils";
import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { CloudDownloadIcon } from "lucide-react";
import { PermissionType, PossiblePackage } from "@/lib/permissions/stytch_original";
import { useStytchMember } from "@stytch/react/dist/b2b";
import { hasAccessToFeature } from "@/lib/models/auth";


export function CropProfileReportModal({ options }: { options: any }) {
  // const { member } = useStytchMember();
  const { toast } = useToast();
  const [link, setLink] = useState<string | undefined | null>();
  const [isGenerating, setIsGenerating] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const createReport = useGenerateProfileReport();

  // const hasPermission = hasAccessToFeature({
  //   name: "Risk Write",
  //   requiredPermissions: [PermissionType.Write, PermissionType.Update, PermissionType.Read],
  //   requiredPackages: [PossiblePackage.RiskManagementCropProfile],
  // }, member);

  // if (hasPermission) {
  //   return (<div></div>)
  // }

  const onGenerateReport = async () => {
    try {
      if (isGenerating) { return; }
      setIsGenerating(true);

      const parseDataResult = GenerateCropProfileReportValidation.safeParse(options);
      if (!parseDataResult.success) {
        toast({
          title: "Invalid filters"
        })
        return;
      }

      const result = await createReport(parseDataResult.data);
      if (!result.success) {
        throw result;
      }

      const nowDate = moment.tz(CommonDestinationTimezone).format("YYYY-MM-DD");
      downloadFromS3(result.data.link, `crop-profile-report-${nowDate}.xlsx`);

      setLink(result.data.link);

      toast({
        title: "Generated",
        description: "",
      });
    } catch (error) {
      setLink(null);
      console.error("Failed to generate crop profile report", error);

      toast({
        title: "Failed to generate report",
        description: "",
        variant: "destructive",
      });
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(status) => {
        if (!status) { setLink(null); }
        setIsOpen(status);
      }}
    >
      <DialogTrigger>
        <span className="sr-only">Generate Profile Report</span>
        <Button onClick={onGenerateReport} className="gap-2" asChild>
          <span>
            <CloudDownloadIcon className="h-4 w-4" />
            Generate Report
          </span>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogTitle className="sr-only">Profile Report</DialogTitle>
        <DialogDescription className="sr-only">Risk Profile Report</DialogDescription>
        {link && (<h3 className="text-bold text-xl">Report Generated</h3>)}
        {isGenerating && (<p>Generating Report</p>)}
        {link && (
          <div className="flex flex-col gap-1 my-2">
            <Separator className="my-2" />
            <p className="text-sm text-muted-foreground">
              Report generated successfully.
            </p>
            <a href={link} target="_blank" rel="noopener noreferrer" className="mt-2 text-xs text-muted-foreground underline decoration-solid decoration-sky-500">Click here to view report, if it doesn't download automatically.</a>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
